module.exports = __webpack_public_path__ + "static/media/9-iron.7df44c0b.png";